, <template>
  <div>
    <el-upload
      ref="xrUpload"
      class="upload-demo"
      :action="uploadUrl"
      :limit="limit"
      :accept="accept"
      :data="paramsObj"
      :on-success="fileUploadSuccess"
      :on-error="fileUploadError"
      :on-preview="handlePreview"
      :file-list="fileList">
      <el-button size="small" type="primary"  >点击上传</el-button>
      <div slot="tip" class="el-upload__tip"  :style="{ color: tipFontColor }">{{tipMessage}}</div>
    </el-upload>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

export default {
  name: "index",
  props: ['businessType', 'tipColor', 'tipMsg', 'value'],
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value(newValue) {
      console.log('最新的值：' + newValue)
      if(newValue != null && newValue != '' && newValue != undefined) {
        this.init();
      }
    }
  },
  data(){
    return {
      fileList: [],
      tipFontColor: '#606266',
      tipMessage: '格式支持doc/docx/pdf，100M以内',
      uploadUrl: process.env.FILE_URL + "/fileWeb/uploadResource",
      paramsObj: new Object(),
      accept: '.docx,.doc,.pdf',
      limit: 1
    }
  },
  created() {
    this.paramsObj['accessToken'] = getToken();
    this.paramsObj['businessType'] = this.businessType;
    if(!!this.tipMsg){
      this.tipMessage = this.tipMsg
    }
    if(!!this.tipColor){
      this.tipFontColor = this.tipColor
    }
    this.init();
  },
  methods: {
    init(){
      this.fileList = [];
      return this.request({
        method:'post',
        url:'/web/service?method=tCoreResource_findById',
        params: {
          id: this.value
        }
      }).then((response) =>{          //这里使用了ES6的语法
        // 请求成功返回的数据
        //如果返回编码不为0，提示失败语
        if(response.code != '0'){
          this.$message.error(response.msg);
          return false;
        }

        let fileList = [];
        if(!!response.data && !!response.data.id){
          let temp = new Object();
          // fileList = response.rows;
          temp['uid'] = response.data.id;
          temp['name'] = response.data.fileName;
          temp['url'] = process.env.FILE_URL + "/upload" + response.data.filePath;
          temp['status'] = 'success';
          fileList.push(temp);
          console.log('++++++++fileList++++++++++++++++++++++++++++++');
          console.log(fileList);

        }
        this.fileList = fileList;
      })
    },
    //上传成功后的操作
    fileUploadSuccess(response){
      console.log('response-------------------------------')
      console.log(response)
      let resourceId = response.resourceId;
      this.value = resourceId;
      this.$emit('change', resourceId);
      this.init();
    },
    //上传失败后的操作
    fileUploadError(e){

    },
    //下载
    handlePreview(file){
      const a = document.createElement('a')
      a.href = file.url
      a.download = file.name || 'download'
      a.target = '_blank' // 可选：避免当前页面跳转
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)

    }
  }
};
</script>

<style scoped>
  .upload-demo{text-align: left; }
  /deep/ .el-upload-list__item.is-success{display: block;}
</style>



// WEBPACK FOOTER //
// src/components/XrFormSingleFile/index.vue